export const MultiBreaksKey = 'breaks-e0xgt' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
